import type { OfferingDisclosures as Disclosures } from '../lib/offerings';
import './OfferingDisclosures.css';

/**
 * The mandatory Rule 506(c) legends, and the forward-looking-statement
 * disclaimer that must accompany any projected figure.
 *
 * Both take their text from the ENGINE rather than from a constant in this file.
 * That is deliberate: the legends are a compliance obligation, and if they lived
 * in the portal they could drift from what the API believes it is disclosing,
 * or be edited by someone changing a layout. There is one source, it is
 * server-side, and a test asserts it is present in the response.
 *
 * These are not decoration and must not be collapsed behind a "read more" —
 * every public view that shows a number is required to carry them.
 */
export function OfferingLegends({ disclosures }: { disclosures: Disclosures }) {
  return (
    <section className="legends" aria-labelledby="legends-heading">
      <h2 id="legends-heading" className="legends__heading">
        Important disclosures
      </h2>
      <ul className="legends__list">
        {disclosures.legends.map((legend) => (
          <li key={legend} className="legends__item">
            {legend}
          </li>
        ))}
      </ul>
    </section>
  );
}

/**
 * The forward-looking disclaimer. Rendered directly beside projected figures,
 * never at the bottom of a long page — a disclaimer a reader has to go looking
 * for is not in the same view as the number it qualifies.
 */
export function ForwardLookingNote({ text }: { text: string }) {
  return (
    <p className="forward-looking" role="note">
      <span className="forward-looking__flag">Projection</span>
      {text}
    </p>
  );
}
